/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

"use client";

import useSWR from "swr";
import useSWRImmutable from "swr/immutable";

import { useAccountId } from "../account/account.hooks";

import { getOptIn, updateOptIn } from "./opt-in.fetch";

interface HookRes {
	isLoading: boolean;
	error: any;
}

interface IsOptInHookRes extends HookRes {
	hasOptIn: boolean;
}
export const useIsOptIn = (): IsOptInHookRes => {
	const accountId = useAccountId();
	const shouldFetch = Boolean(accountId);

	const { data, error } = useSWR(shouldFetch ? `optin-${accountId}` : null, getOptIn, {
		errorRetryCount: 0,
	});

	return {
		hasOptIn: data?.settingValue === true,
		isLoading: Boolean(!data && !error && shouldFetch),
		error,
	};
};

interface UpdateOptInHookRes extends HookRes {
	isOptInSuccess: boolean;
}
export const useUpdateOptIn = (execute: boolean): UpdateOptInHookRes => {
	const accountId = useAccountId();
	const shouldFetch = Boolean(execute && accountId);

	const { data, error } = useSWRImmutable(shouldFetch ? `optin-update-${accountId}` : null, updateOptIn, {
		errorRetryCount: 0,
	});

	return {
		isOptInSuccess: data?.success === true,
		isLoading: Boolean(!data && !error && shouldFetch),
		error: error || data?.success === false,
	};
};
